import React from 'react';
import './subHeader.component.sass'
import {Breadcrumb} from "rsuite";
import {Link} from "react-router-dom";

const SubHeaderComponent = ({pageName, imageSrc, isSingleProduct, news}) => {
    return (
        <div className='sub-header'>
            <div className='need-max-width'>
                <div className='sub-header-right'>
                    <h2>{pageName}</h2>
                    <div>
                        <Link to='/'>صفحه اصلی</Link><span style={{fontWeight: '900'}}>&nbsp; 〉</span>
                        {
                            isSingleProduct ?
                                <span><Link to='/product'>محصولات</Link><span style={{fontWeight: '900'}}>&nbsp; 〉</span></span>
                                : null
                        }
                        {
                            news ?
                                <Link to='/news'>{pageName}</Link>
                                :
                                <span>{pageName}</span>
                        }
                        {
                            news ?
                                <span><span style={{fontWeight: '900'}}>&nbsp; 〉</span><span style={{color:'#ffbb89'}}>{news}</span></span>
                                : null
                        }
                    </div>
                </div>
                <div className='sub-header-left'>
                    <img src={imageSrc} alt='Xitonix Header' />
                </div>
            </div>
        </div>
    );
};

export default SubHeaderComponent;